import { EllipsisVerticalIcon } from "@heroicons/react/24/outline";

interface GripHandleProps {
  className?: string;
}

export const GripHandle: React.FC<GripHandleProps> = ({ className = "" }) => (
  <div className={`flex ${className}`}>
    <EllipsisVerticalIcon className="h-6 w-6" />
    <EllipsisVerticalIcon className="h-6 w-6 -ml-4" />
  </div>
);
